import * as React from 'react';

export interface UseAnglePickerParams {
  onAngleChange: (value: number) => void;
}
export const useAnglePicker = ({ onAngleChange }: UseAnglePickerParams) => {
  const [isDragging, setIsDragging] = React.useState<boolean>(false);
  const containerRef = React.useRef<HTMLDivElement>(null);

  const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;

    const container = containerRef.current;
    if (!container) return;

    const containerRect = container.getBoundingClientRect();
    const centerX = containerRect.left + containerRect.width / 2;
    const centerY = containerRect.top + containerRect.height / 2;

    const mouseX = event?.clientX || 0;
    const mouseY = event?.clientY || 0;

    const newAngle = Math.atan2(mouseY - centerY, mouseX - centerX);
    const degrees = Math.round((newAngle * 180) / Math.PI);

    /**
     * NOTE: for backwards compatibility, we need to invert the angle
     */
    onAngleChange(degrees > 0 ? -degrees : Math.abs(degrees));
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseDown = () => {
    setIsDragging(true);
  };

  return {
    containerRef,
    handleMouseMove,
    handleMouseUp,
    handleMouseDown,
  };
};
